import { render, staticRenderFns } from "./LgInput.vue?vue&type=template&id=a3a632f4&scoped=true&"
import script from "./LgInput.vue?vue&type=script&lang=js&"
export * from "./LgInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a632f4",
  null
  
)

export default component.exports